import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-notification-lib',
  template: `
    <p>
      notification-lib works!
    </p>
  `,
  styles: [
  ]
})
export class NotificationLibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
